export const EXISTING_USER_SCOPE = {
  SAME_ORGANIZATION: 'SAME_ORGANIZATION',
  OTHER_ORGANIZATION: 'OTHER_ORGANIZATION',
};

// Reads a failed user-creation response and, when it means "this email is
// already taken", returns what the caller needs to react:
//   { scope, email, userId, organizationId, message }
// Returns null for every other failure.
//
// The API answers with a structured body carrying `scope`:
//   SAME_ORGANIZATION  -> already a member here, nothing to offer
//   OTHER_ORGANIZATION -> exists elsewhere, can be added to this organization
//                         using the returned userId
// Older responses only carried a 409 or the bare "already exists" message, so
// those still resolve, defaulting to OTHER_ORGANIZATION (the case that has an
// action attached).
export const getExistingUserError = (error) => {
  const data = error?.response?.data;
  const body = typeof data === 'object' && data !== null ? data : {};
  const message =
    (typeof data === 'string' ? data : body.message || body.error) || error?.message || '';
  const looksExisting =
    error?.response?.status === 409 ||
    (typeof message === 'string' && /already exists|already a member/i.test(message));

  if (!looksExisting) {
    return null;
  }

  return {
    scope:
      body.scope === EXISTING_USER_SCOPE.SAME_ORGANIZATION
        ? EXISTING_USER_SCOPE.SAME_ORGANIZATION
        : EXISTING_USER_SCOPE.OTHER_ORGANIZATION,
    email: body.email,
    userId: body.userId,
    organizationId: body.organizationId,
    message: typeof message === 'string' ? message : '',
  };
};

export const isExistingUserError = (error) => getExistingUserError(error) !== null;

export default isExistingUserError;
